import React, { useContext, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import {
  Box,
  Button,
  makeStyles,
  TableRow,
  TextField,
  Typography,
} from "@material-ui/core";

import { FormattedMessage } from "react-intl";
import useTabStyles from "../../styles/Tab.style";
import useStyles from "./IcipWithdrawTarificationTab.style";
import Paginator, { DataTypeEnum } from "../../../../models/Paginator";
import {
  ICIPAdminActionTypeEnum,
  ICIPAdminDispatchContext,
} from "../../../../context/ICIPAdminContext";
import CurrencyService from "../../../../services/CurrencyService";
import { AddIcipWithdrawTarification } from "./components/AddIcipWithdrawTarification";
import { EditIcipWithdrawTarification } from "./components/EditIcipWithdrawTarification";
import Grid from "@material-ui/core/Grid";
import IcipWithdrawTarificationService from "../../../../services/IcipWithdrawTarificationService";
import { IcipWithdrawTarificationsTabPanel } from "../../tab-panels/icip-withdraw-tarifications/IcipWithdrawTarificationsTabPanel";
import TableData, {
  StyledTableCell,
  StyledTableRow,
} from "../../components/TableData";
import IcipWithdrawTafification from "../../../../models/IcipWithdrawTarification";
import { InputField } from "../../../../components/input-field/InputField";
import { Autocomplete } from "@material-ui/lab";

interface IcipWithdrawTarificationsTabProps {}

export interface IcipWithdrawTarificationsTabData {
  original: Paginator;
  filtered: Paginator;
}

export const IcipWithdrawTarificationsTab = (
  props: IcipWithdrawTarificationsTabProps
) => {
  const classes = useStyles();
  const tabClasses = useTabStyles(props);
  const intl = useIntl();
  const { formatMessage } = useIntl();
  // Context
  const dispatch = useContext(ICIPAdminDispatchContext);
  // State
  const [paginator, setPaginator] = useState((): Paginator => null);
  const [currencies, setCurrencies] = useState([]);
  const [tarifications, setTarifications] = useState((): any => []);
  const [modalType, setModalType] = useState(true);
  const [selectedTarification, setSelectedTarification] = useState(null);
  const [
    editIcipWithdrawModalOpened,
    setEditIcipWithdrawModalOpened,
  ] = useState(false);
  const [searchData, setSearchData] = useState({});
  const [error, setError] = useState(null);

  // Callback
  const openEditModal = (e, data) => {
    setModalType(false);
    setSelectedTarification(data);
    if (editIcipWithdrawModalOpened !== true) {
      toggleEditIcipWithdrawModal();
    }
    //toggleEditIcipWithdrawModal();
  };

  const toggleEditIcipWithdrawModal = () => {
    setEditIcipWithdrawModalOpened(!editIcipWithdrawModalOpened);
    console.log(modalType);
    setModalType(!modalType);
  };

  const handleDataChange = (name: string, value: string) => {
    let currentSearchData = { ...searchData };
    currentSearchData[name] = value;
    setSearchData(currentSearchData);
  };

  const handleSearchData = () => {
    IcipWithdrawTarificationService.searchWithdraw(searchData).then(
      (response) => {
        if (response.isSuccess && response.data.code === 100) {
          let reqPaginator = Paginator.fromJson(
            JSON.parse(JSON.stringify(response.data.data)),
            DataTypeEnum.icipWithdrawTarification
          );

          setPaginator(reqPaginator);
          setTarifications(reqPaginator.items);
        } else {
          setError(true);
        }
      }
    );
  };

  const paginatorAction = (page: number) => {
    fetchData(page);
  };

  // Fetch data

  const fetchData = (page: number = 1) => {
    IcipWithdrawTarificationService.getAll(page).then((response) => {
      if (response.isSuccess && response.data.code === 100) {
        let reqPaginator = Paginator.fromJson(
          JSON.parse(JSON.stringify(response.data.data)),
          DataTypeEnum.icipWithdrawTarification
        );
        setPaginator(reqPaginator);
        dispatch({
          type: ICIPAdminActionTypeEnum.loaded,
        });
      } else {
        dispatch({
          type: ICIPAdminActionTypeEnum.error,
          data: {
            error: intl.formatMessage({ id: "error.unknownError" }),
          },
        });
      }
    });
  };
  const loadCurrencies = () => {
    const response = CurrencyService.supportedCurrencies();

    response.then((response) => {
      if (response.isSuccess && response.data.code === 100) {
        let currencies = JSON.parse(JSON.stringify(response.data.data));

        setCurrencies(currencies);
      } else {
        setCurrencies(currencies);
      }
    });
  };

  useEffect(() => {
    dispatch({
      type: ICIPAdminActionTypeEnum.loading,
    });
    fetchData();
    loadCurrencies();
  }, []);

  const renderIcipWithdrawTableRows = () => {
    return paginator.items.map((row, index) => {
      let tarification = row as IcipWithdrawTafification;
      return (
        <>
          <StyledTableRow key={index}>
            <StyledTableCell component="td" scope="row">
              {`${tarification.min_amount}`}
            </StyledTableCell>
            <StyledTableCell component="td" scope="row">
              {tarification.max_amount}
            </StyledTableCell>
            <StyledTableCell component="td" scope="row">
              {tarification.commission_percentage}
            </StyledTableCell>
            <StyledTableCell component="td" scope="row">
              {tarification.fees}
            </StyledTableCell>
            <StyledTableCell component="td" scope="row">
              {tarification.currency.code}
            </StyledTableCell>
            <StyledTableCell component="td" scope="row">
              <Button
                color="secondary"
                variant="contained"
                className={classes.subButton}
                value={tarification.id}
                onClick={(e) => openEditModal(e, tarification)}
              >
                <FormattedMessage id="sharedScreen.editIcipWithdrawTarification" />
              </Button>
            </StyledTableCell>
          </StyledTableRow>
        </>
      );
    });
  };

  const renderIcipWithdrawTableHeader = () => {
    return (
      <TableRow>
        <StyledTableCell>
          <FormattedMessage id="sharedScreen.minAmount" />
        </StyledTableCell>
        <StyledTableCell align="left">
          <FormattedMessage id="sharedScreen.maxAmount" />
        </StyledTableCell>
        <StyledTableCell align="left">
          <FormattedMessage id="sharedScreen.commissionPercentage" />
        </StyledTableCell>
        <StyledTableCell align="left">
          <FormattedMessage id="sharedScreen.fixedFees" />
        </StyledTableCell>
        <StyledTableCell align="left">
          <FormattedMessage id="sharedScreen.currency" />
        </StyledTableCell>
        <StyledTableCell align="left">
          <FormattedMessage id="sharedScreen.actions" />
        </StyledTableCell>
      </TableRow>
    );
  };

  //Render
  const render = () => {
    return (
      <Box component="div" className={classes.tabsPanel}>
        <Box component="div" className={classes.wrapper}>
          <Box component="div" className={classes.leftHeader}>
            <Typography variant="h3" component="h3">
              <FormattedMessage id="sharedScreen.withTarification" />
            </Typography>
            <Box component="div" className={classes.trailing}>
              <Typography variant="h3" component="h3">
                {`# ${paginator.total}`}
              </Typography>
            </Box>
          </Box>
        </Box>
        <Grid item xs={12} sm={12} lg={12} className={classes.searchGroup}>
          <Grid item xs={12} sm={3} lg={3} className={classes.testField}>
            <InputField
              className={classes.testField}
              type="number"
              fullWidth
              label={formatMessage({ id: "sharedScreen.searchMinAmount" })}
              placeholder={formatMessage({ id: "sharedScreen.minAmount" })}
              name="min_amount_search"
              onChange={(event) =>
                handleDataChange(event.target.name, event.target.value)
              }
            />
          </Grid>
          <Grid item xs={12} sm={3} lg={3} className={classes.testField}>
            <InputField
              className={classes.testField}
              type="number"
              fullWidth
              label={formatMessage({ id: "sharedScreen.searchMaxAmount" })}
              placeholder={formatMessage({ id: "sharedScreen.maxAmount" })}
              name="max_amount_search"
              onChange={(event) =>
                handleDataChange(event.target.name, event.target.value)
              }
            />
          </Grid>
          <Grid item xs={12} sm={3} lg={3} className={classes.testField1}>
            <Autocomplete
              className={classes.searchAuto}
              id="currencies"
              options={currencies}
              renderInput={(param) => (
                <TextField
                  {...param}
                  label={formatMessage({ id: "sharedScreen.searchCurrency" })}
                  variant="outlined"
                  size="small"
                />
              )}
              getOptionLabel={(Option) => Option.code}
              //onChange={formik.handleChange}
              onChange={(event, currency) => {
                handleDataChange("currency", currency);
              }}
            />
          </Grid>
          <Grid item xs={12} sm={3} lg={3} className={classes.testField}>
            <Button
              color="secondary"
              variant="contained"
              className={classes.testField1}
              //value={tarification.id}
              onClick={handleSearchData}
            >
              <FormattedMessage id="sharedScreen.searchTarif" />
            </Button>
          </Grid>
        </Grid>
        <br />
        <br />
        <br />
        
        <Grid item xs={12} sm={6} lg={12}>
          <TableData
            paginator={
              paginator.total !== 0
                ? {
                    total: paginator.total,
                    page: paginator.page,
                    totalPage: paginator.total_page,
                    title: "",
                    handlePrevAction:
                      paginator.prev_page !== null
                        ? () => paginatorAction(paginator.page - 1)
                        : null,
                    handleNextAction:
                      paginator.next_page !== null
                        ? () => paginatorAction(paginator.page + 1)
                        : null,
                  }
                : null
            }
            rows={renderIcipWithdrawTableRows()}
            header={renderIcipWithdrawTableHeader()}
          />
        </Grid>
      </Box>
    );
  };
  return (
    <>
      {paginator !== null ? (
        <Box className={classes.root}>
          <Box className={classes.wrapper}>
            <Grid xs={12} sm={12} lg={12} container>
              <Grid
                className={classes.myCard}
                container
                alignItems="flex-start"
                item
                xs={12}
                sm={3}
                lg={3}
              >
                {modalType ? (
                  <AddIcipWithdrawTarification
                    onSubmitCallback={fetchData}
                    currencies={currencies}
                  />
                ) : (
                  <EditIcipWithdrawTarification
                    closeCallback={toggleEditIcipWithdrawModal}
                    onSubmitCallback={fetchData}
                    //onRefresh={onRefresh}
                    isOpened={editIcipWithdrawModalOpened}
                    currencies={currencies}
                    tarification={selectedTarification}
                    //handleEditCallBack={openEditModal}
                  />
                )}
              </Grid>
              <Grid
                container
                alignItems="flex-start"
                item
                xs={12}
                sm={6}
                lg={8}
              >
                {render()}
              </Grid>
              {/*<Grid container alignItems="flex-start" item xs={6} lg={7}>
                <IcipWithdrawTarificationsTabPanel
                  currencies={currencies}
                  paginator={paginator.filtered}
                  handleEditCallBack={openEditModal}
                  currencies={currencies}
                />
                </Grid>*/}
            </Grid>
          </Box>
        </Box>
      ) : (
        <></>
      )}
    </>
  );
};
